import { createSSRApp, h, } from "vue";
import { createInertiaApp } from "@inertiajs/vue3";
// import { resolvePageComponent } from "laravel-vite-plugin/inertia-helpers";
import "nprogress/nprogress.css";
import "@/assets/nprogress-custom.css";
// import "@/assets/app.css";
// import "@assets/main.scss";
import { createPinia } from "pinia";
import PrimeVue from "primevue/config";
import DatePicker from "primevue/datepicker";
// import "primevue/resources/primevue.min.css"; // Import PrimeVue core CSS
import FileUpload from 'primevue/fileupload';
import DataTable from "primevue/datatable";
import DataView from "primevue/dataview";
import Column from "primevue/column";
import Row from "primevue/row";
import ColumnGroup from "primevue/columngroup";
import InputNumber from "primevue/inputnumber";
import RadioButton from "primevue/radiobutton";
import Message from "primevue/message";

import DialogService from "primevue/dialogservice";
import DynamicDialog from "primevue/dynamicdialog";
import Layout from "@/Shared/Layout.vue";
import DealerCheckout from "@/Shared/DealerCheckout.vue";
import CustomerService from "@/Shared/CustomerService.vue"
import Account from "@/Shared/Account.vue"
import ApiNav from "@/Shared/ApiNav.vue";
import Drawer from "primevue/drawer";
import Inplace from "primevue/inplace";
import InputText from "primevue/inputtext";
import Checkbox from 'primevue/checkbox';
import TextArea from "primevue/textarea";
import InputMask from "primevue/inputmask";
import SelectButton from "primevue/selectbutton";
import Select from "primevue/select";
import Password from "primevue/password";
import Textarea from 'primevue/textarea';
import VirtualScroller from "primevue/virtualscroller";
import { ZiggyVue } from "ziggy-js";
import { Ziggy } from "@/ziggy";
import { VueShowdownPlugin, showdown } from "vue-showdown";
import mermaid from "mermaid";
import CustomSelect from "@/components/CustomSelect.vue";
import NumberInput from "@/components/NumberInput.vue";
import * as Sentry from "@sentry/vue";
import VueDatePicker from '@vuepic/vue-datepicker';
import Tooltip from "@/components/Tooltip.vue";
import 'highlight.js/styles/stackoverflow-light.css'
import hljsVuePlugin from "@highlightjs/vue-plugin";

import * as cheerio from 'cheerio';

globalThis.cheerio = cheerio;
showdown.extension('mermaid', () => {
    return {
        type: 'output',
        filter(text) {
            // Browser HTML parsing lowercases tags, which turns Vue components like
            // <Link> into void <link> elements. Protect PascalCase tags first.
            const vueTags = [];
            const withPlaceholders = text.replace(
                /<\/?[A-Z][A-Za-z0-9]*\b[^>]*>/g,
                (tag) => {
                    const index = vueTags.length;
                    vueTags.push(tag);
                    return `<!--VUE_COMPONENT_TAG_${index}-->`;
                }
            );

            const doc = document.implementation.createHTMLDocument("");
            doc.body.innerHTML = withPlaceholders;
            const blocks = doc.body.querySelectorAll("pre > code");
            blocks.forEach((codeEl) => {
                if (!codeEl.innerHTML.includes("mermaid")) {
                    return;
                }
                let raw = codeEl.textContent ?? "";
                raw = raw.replace(/^```mermaid\n?/, "").replace(/\n?```$/, "");
                const div = doc.createElement("div");
                div.className = "mermaid";
                div.textContent = raw;
                codeEl.parentElement?.replaceWith(div);
            });

            return doc.body.innerHTML.replace(
                /<!--VUE_COMPONENT_TAG_(\d+)-->/g,
                (_, index) => vueTags[Number(index)] ?? ""
            );
        }
    }
});

mermaid.initialize({
    startOnLoad: false,
});
const appName =
    window.document.getElementsByTagName("title")[0]?.innerText || "Laravel";

const pinia = createPinia();
if (import.meta.hot) {
    import.meta.hot.accept();
}
createInertiaApp({
    title: (title) => {
        if (!title) {
            return ` ${import.meta.env.VITE_APP_TITLE}`;
        }
        return `${title}`
    },
    resolve: (name) => {
        const pages = import.meta.glob("./Pages/**/*.vue", { eager: true });
        let page = pages[`./Pages/${name}.vue`];
        let specialLayoutNames = [
            'CartPagePrint',
            "D2CCheckoutPage",
            "DealerCheckout/Shipping",
            "DealerCheckout/Billing",
            "DealerCheckout/Review",
            "CustomerService/CustomerCare",
            "CustomerService/Faqs",
            "CustomerService/CmsPage",
            "CustomerService/RetailLocator",
            "CustomerService/OrderStatus",
            "ApiDocs/CmsPage",
        ];
        if (!specialLayoutNames.includes(name)) {
            page.default.layout = Layout;

        }


        if(name.startsWith('ApiDocs')){
            page.default.layout = ApiNav;
        }

        if(name.startsWith('UserAccount/')){
            page.default.layout = Account;
        }

        if(name.startsWith('CustomerService/')){
            page.default.layout = CustomerService;
        }

        if(['DealerCheckout/Shipping', 'DealerCheckout/Billing', 'DealerCheckout/Review'].includes(name)){
            page.default.layout = DealerCheckout;
        }

        return page;
    },
    setup({ el, App, props, plugin }) {
        let appInstance = createSSRApp({ render: () => h(App, props) })
        .use(plugin)
            .use(PrimeVue, {
                unstyled: true,
                pt: {
                    datatable: {
                        tableContainer: {},
                        table: {
                            class: "table"
                        },
                        thead: {},
                        bodyRow: {
                            class: "table-item"
                        }
                    },
                    column: {
                        headerCell: {},
                        bodyCell: {}
                    },
                    inputnumber: {
                        pcInput: {
                            class: "mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                        }
                    },
                    password: {
                        root: {
                            class: 'primePassword'
                        }
                    },
                    dialog: {
                        root: {
                            class: "bg-white overflow-auto",
                            style: "width:100%;"
                        },
                        header: {
                            class: "p-3 bg-gray-800 text-white flex flex-row space-between"
                        },
                        title: {
                            class: "text-lg font-semibold"
                        }
                    },
                    tooltip: {
                        root: {
                            class: "bg-rothcoBlack text-rothcoWhite",
                        }
                    },
                    drawer: {
                        root: {
                            class: "bg-rothcoWhite popout"
                        },
                        header: {
                            class: "header-section"
                        },
                        content: {
                            class: 'content-section'
                        }
                    },
                    megamenu: {
                        root: {
                            class: "menu-container"
                        },
                        rootList: {
                            class: ""
                        },
                        item: {
                            class: "nav-main-item"
                        },
                        itemLink: {
                            class: "headline-l"
                        }
                    },
                    inplace: {
                        display: {
                            class: 'paragraph-default'
                        }
                    }
                },
            })
            .use(DialogService)
            .use(pinia)
            .use(ZiggyVue, Ziggy)
            .use(VueShowdownPlugin, {
                flavor: 'github',
                options: {
                    extensions: ['mermaid'],
                    emoji: true,
                    tables: true,
                    ghCodeBlocks: true,
                    tasklists: true,
                    moreStyling: true
                }
            })
            .component('VueDatePicker', VueDatePicker)
            .component("PrimeDrawer", Drawer)
            .component("PrimeDatePicker", DatePicker)
            .component("PrimeFileUpload", FileUpload)
            .component("PrimeDataTable", DataTable)
            .component("PrimeDataView", DataView)
            .component("PrimeColumn", Column)
            .component("PrimeVueRow", Row)
            .component("PrimeColumnGroup", ColumnGroup)
            .component("PrimeInputNumber", InputNumber)
            .component("PrimeRadioButton", RadioButton)
            .component("PrimeMessage", Message)
            .component("DynamicDialog", DynamicDialog)
            .component("PrimeInplace", Inplace)
            .component("PrimeInputText", InputText)
            .component("PrimeCheckbox", Checkbox)
            .component("PrimeTextArea", TextArea)
            .component("PrimeVueSelect", Select)
            .component("PrimeSelectButton", SelectButton)
            .component("PrimePassword", Password)
            .component("PrimeInputMask", InputMask)
            .component("PrimeVirtualScroller", VirtualScroller)
            .component("CustomSelect", CustomSelect)
            .component("NumberInput", NumberInput)
            if(window.sentry == null){
                Sentry.init({
                    app: appInstance,
                    dsn: "https://735ca44d1644faefe5e760d946b0e3e4@o969564.ingest.us.sentry.io/4509112021942272",
                    environment: import.meta.env.VITE_APP_ENV,
                    ignoreErrors: [
                        /AbortError/i,
                        /Non-Error promise rejection captured with value: New request made/i,
                        /Failed to resolve module specifier "@vue\/compiler-dom"\. Relative references must start with either "\/", "\.\/", or "\.\.\//i,
                        /Uncaught \(in promise\) New request made/i,
                        /Uncaught \(in promise\) TypeError: Cannot read properties of null \(reading 'children'\)/i,
                        '/Uncaught TypeError: Failed to resolve module specifier "@vue/compiler-dom". Relative references must start with either "/", "./", or "../".',
                        'Uncaught TypeError: The specifier “@vue/compiler-dom” was a bare specifier, but was not remapped to anything. Relative module specifiers must start with “./”, “../” or “/”.',
                        "Module name, '@vue/compiler-dom' does not resolve to a valid URL.",
                        // Harmless PayPal SDK noise when its button iframe is torn down
                        /Can not send postrobot_method\. Target window is closed/i,
                        /Target window is closed/i,
                    ],
                    integrations: [
                      Sentry.browserTracingIntegration(),
                      Sentry.replayIntegration({
                        networkDetailAllowUrls: [
                            /^https?:\/\/(www\.|beta\.|alpha\.)?rothco\.com\/.*$/,
                        ],
                        maskAllText: false,
                        blockAllMedia: false,
                      }),
                      Sentry.browserProfilingIntegration()
                    ],
                    // Tracing
                    tracesSampleRate: 1.0, // Capture 100% of the transactions
                    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
                    tracePropagationTargets: [/^https?:\/\/(www\.|beta\.|alpha\.)?rothco\.com/, /^https?:\/\/(www\.|beta\.|alpha\.)?rothco\.com\/api/,],
                    // Session Replay
                    replaysSessionSampleRate: import.meta.env.VITE_APP_ENV == 'production' ? 0 : .2, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
                    replaysOnErrorSampleRate: import.meta.env.VITE_APP_ENV == 'production' ? 0 : 1, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    
                    profilesSampleRate: 1.0, // This sets the sample rate at 100%. You may want to change it to a lower rate in production.
                  });
    
                window.sentry = Sentry;
            }

            appInstance.config.errorHandler = (err, vm, info) => {
                let ignorableErrors = [
                    'TypeError: R is null',
                    "Cannot read properties of null (reading 'getBoundingClientRect')",
                    'Can not send postrobot_method. Target window is closed',
                    'Target window is closed',
                ]
                let isIgnorable = ignorableErrors.some((error) => {
                    return err.message.includes(error);
                });
                if(isIgnorable){
                    return;
                }
                window.sentry?.captureException(err, {
                    extra: {
                        info: info
                    }
                });
                // console.error(err, info);

            }
            appInstance.mount(el);
    },
    progress: false
});